import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function UserAgreementModal({ isOpen, onClose }) {
  const [isChecked, setIsChecked] = useState(false);

  if (!isOpen) return null;

  const handleClose = () => {
    if (isChecked) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-yellow-100 bg-opacity-80 flex items-center justify-center p-4">
      <div className="bg-white max-h-[90vh] overflow-y-auto w-full max-w-6xl rounded-2xl shadow-lg border border-yellow-400 relative flex flex-col">
        <div className="p-6 pb-32">
          <h2 className="text-2xl font-bold mb-4 text-yellow-600">
            GITME USER AGREEMENT
          </h2>
          <p className="text-sm text-gray-800 mb-6">
            <strong>Effective Date:</strong> 15.05.2025
          </p>
          <div className="text-sm space-y-4 text-gray-800">
            <p>
              <strong>Effective Date:</strong> 15.05.2025
            </p>
            <p>
              This User Agreement (“Agreement”) is entered into between Defy
              Digital Software Services Inc. (“Gitme”) and the user (“User”) who
              registers to the website www.gitdotme.com or platforms provided by
              Gitme. Gitme provides an AI-supported performance and effort
              analytics platform for software developers. By registering to the
              platform, the User declares that they have read, understood, and
              accepted all the terms of this Agreement.
            </p>

            <p>
              <strong>1. DESCRIPTION OF THE SERVICE</strong>
              <br />
              Gitme offers users an AI-based evaluation service that analyzes
              the productivity, contribution level, and work habits of software
              developers. The service is only available through digital
              platforms provided by Gitme.
            </p>

            <p>
              <strong>2. SUBSCRIPTION AND PAYMENT TERMS</strong>
              <br />
              2.1. The User agrees to choose one of the monthly or annual
              subscription packages to access the Gitme platform and pay the
              fees specified in return.
              <br />
              2.2. Payment is automatically collected via a valid credit card
              provided by the User during registration. The payment
              infrastructure is provided through secure third-party providers.
              <br />
              2.3. Unless otherwise stated, monthly or annual subscription plans
              automatically renew. The relevant fee will be charged via the
              User’s payment method at the renewal period.
            </p>

            <p>
              <strong>3. CANCELLATION OF SUBSCRIPTION</strong>
              <br />
              3.1. The User may cancel their subscription at any time through
              their account settings. The cancellation becomes effective
              starting from the next billing cycle; no refund will be made for
              the current billing period.
              <br />
              3.2. Gitme may suspend or terminate the subscription unilaterally
              in cases of abuse, payment failure, or misuse of the platform.
            </p>

            <p>
              <strong>4. USER RESPONSIBILITIES</strong>
              <br />
              4.1. The User confirms that the information provided on the
              platform is accurate, up-to-date, and belongs to them.
              <br />
              4.2. The User agrees to use the platform services solely for
              lawful purposes and not to violate the rights of third parties.
            </p>

            <p>
              <strong>5. GITME’S RESPONSIBILITY</strong>
              <br />
              5.1. Gitme does not guarantee that the platform will operate
              error-free or without interruptions. However, it will make
              reasonable efforts to ensure service continuity.
              <br />
              5.2. The analyses and scores provided by AI are for informational
              purposes only; Gitme cannot be held responsible for decisions made
              based on this data.
            </p>

            <p>
              <strong>6. PRIVACY AND DATA USAGE</strong>
              <br />
              6.1. User data is processed in accordance with Gitme’s Privacy
              Policy. Credit card information is not stored by Gitme but
              processed via the payment infrastructure provider.
              <br />
              6.2. Gitme may use users’ contribution data in an anonymized form
              for statistical analysis and product development purposes.
            </p>

            <p>
              <strong>7. MODIFICATIONS TO THE AGREEMENT</strong>
              <br />
              Gitme reserves the right to unilaterally modify this Agreement.
              Changes become effective on the date they are published on the
              platform.
            </p>

            <p>
              <strong>8. DISPUTE RESOLUTION</strong>
              <br />
              This Agreement is subject to the laws of the Republic of Türkiye.
              The parties agree that Istanbul (Anatolian) Courthouse Courts and
              Enforcement Offices shall have jurisdiction.
            </p>

            <p>
              By accepting this Agreement, you acknowledge that you have started
              using the platform and accepted all the above terms.
            </p>
          </div>
        </div>

        {/* Fixed footer */}
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-yellow-300 p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between max-w-6xl mx-auto">
          <label className="flex items-start text-sm text-gray-700">
            <input
              type="checkbox"
              className="mt-1 mr-2 accent-yellow-500"
              checked={isChecked}
              onChange={e => setIsChecked(e.target.checked)}
            />
            <span>I have read and accept the agreement.</span>
          </label>

          <button
            onClick={handleClose}
            disabled={!isChecked}
            className={`mt-2 sm:mt-0 px-4 py-2 rounded-xl transition text-white ${
              isChecked
                ? 'bg-yellow-500 hover:bg-yellow-600'
                : 'bg-gray-300 cursor-not-allowed'
            }`}
          >
            Confirm and Close
          </button>
        </div>
      </div>
    </div>
  );
}

UserAgreementModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
